<template>
  <div>
    <div style="text-align: center">
      <h4 class="titulo-component">Lista de Espera — Publicação Oficial</h4>
      <span>consultado em {{ new Date().toLocaleDateString() }}</span>
    </div>

    <el-row :gutter="10" class="u-mt-20 u-mb-20 filtros-lista">
      <el-col :xs="24" :sm="14" :md="14">
        <el-select v-model="processoId" placeholder="Selecione o processo" @change="carregar" style="width: 100%;">
          <el-option v-for="p in processos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="10" :md="10">
        <el-select v-model="instituicaoId" placeholder="Todas as escolas" clearable filterable
          @change="carregar" style="width: 100%;">
          <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <div v-if="carregando" style="text-align: center; padding: 30px;">
      <i class="el-icon-loading" style="font-size: 26px;"></i>
    </div>

    <el-alert v-else-if="erro" :title="erro" :closable="false" type="info" show-icon></el-alert>

    <div v-else-if="lista">
      <el-alert type="info" :closable="false" show-icon class="u-mb-15"
        :title="lista.aviso"
        description="Em cumprimento à transparência, a publicação exibe apenas posição, protocolo, iniciais do nome e data de inscrição."></el-alert>

      <div class="container-tabela">
        <table class="tabela-publica">
          <thead>
            <tr>
              <th style="width: 70px;">Posição</th>
              <th style="width: 170px;">Protocolo</th>
              <th>Candidato</th>
              <th style="width: 130px;">Situação</th>
              <th style="width: 120px;">Inscrição</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(l, i) in lista.lista" :key="i">
              <td class="centro">{{ l.posicao || '—' }}</td>
              <td>{{ l.protocolo }}</td>
              <td>{{ l.nome_iniciais }}</td>
              <td class="centro">{{ rotulo(l.situacao) }}</td>
              <td class="centro">{{ formata(l.data_inscricao) }}</td>
            </tr>
            <tr v-if="lista.lista.length === 0">
              <td colspan="5" class="centro">Nenhum inscrito publicado neste recorte.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="total">{{ lista.total }} inscrito(s) publicado(s).</p>
    </div>
  </div>
</template>
<script>
/**
 * BLOCO D — item 66 do edital (Timbé do Sul/SC): publicação de transparência (LDB).
 *
 * Endpoint PÚBLICO. O backend só publica quando o processo tem `publica_lista = true`, e
 * devolve exclusivamente posição, protocolo, nome com iniciais e data. Nenhum dado
 * sensível chega até esta tela — não há o que filtrar aqui.
 */
export default {
  data () {
    return {
      carregando: true,
      erro: '',
      processos: [],
      instituicoes: [],
      processoId: '',
      instituicaoId: '',
      lista: null
    }
  },
  mounted () {
    this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/lista-espera-publica/processos`)
      .then(r => {
        this.processos = (r.data && r.data.processos) ? r.data.processos : []
        this.carregando = false

        if (this.processos.length === 1) {
          this.processoId = this.processos[0].id
          this.carregar()
        } else if (this.processos.length === 0) {
          this.erro = 'Não há processo de inscrição disponível para consulta no momento.'
        }
      })
      .catch(() => { this.carregando = false; this.erro = 'Não foi possível carregar os processos.' })
  },
  methods: {
    carregar () {
      if (!this.processoId) return

      this.carregando = true
      this.erro = ''
      this.lista = null

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/lista-espera-publica/instituicoes/${this.processoId}`)
        .then(r => { this.instituicoes = (r.data && r.data.instituicoes) ? r.data.instituicoes : [] })
        .catch(() => { this.instituicoes = [] })

      const base = `${this.$store.state.config.baseUrlApi}/api/lista-espera-publica/publicar/${this.processoId}`

      this.$axios.get(base + (this.instituicaoId ? '/' + this.instituicaoId : ''))
        .then(r => {
          this.carregando = false
          if (r.data && r.data.erro) { this.erro = r.data.erro; return }
          this.lista = r.data
        })
        .catch(() => { this.carregando = false; this.erro = 'Não foi possível carregar a lista.' })
    },
    formata (d) { return d ? String(d).substring(0, 10).split('-').reverse().join('/') : '—' },
    rotulo (s) {
      const r = { classificado: 'Classificado', lista_espera: 'Lista de espera', encaminhado: 'Encaminhado' }
      return r[s] || s
    }
  }
}
</script>
<style scoped>
.container-tabela { overflow-x: auto; }
.tabela-publica { width: 100%; border-collapse: collapse; }
.tabela-publica th, .tabela-publica td { border: 1px solid #e6e6e6; padding: 8px 10px; font-size: 13px; }
.tabela-publica th { background: #fafafa; font-weight: 600; color: #555; text-align: left; }
.tabela-publica tbody tr:nth-child(even) { background: #fcfcfc; }
.centro { text-align: center; }
.total { margin-top: 12px; font-size: 12px; color: #888; text-align: right; }
</style>
